import React from "react";
import { useEffect } from 'react';
function AboutUs() {

     useEffect(() => {
          window.scrollTo(0, 0);
        }, []);

  return (
    <section className="product_damage_return_policy_section pt-40 pb-40">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="inner-box">
              <p>
                AAMMII’s mission is to provide online shopping experience to you
                by ensuring that only the best organic products are available
                for all your needs.
              </p>
              <p>
                we also ensure efficient customer service to take care of all
                your queries and issues over efficient delivery.
              </p>
              <p>
                Every products that are available at www.aammii.com is at the
                highest quality over a competitive price
              </p>
              <p>
                At AAMMII, we want you to ‘feel good’ not only about the
                products that you buy, but also about your complete customer
                experience. We are welcoming you to experience aback-to-nature
                world of unique, organic, sustainable lifestyle products that
                will change the very way you shop.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutUs;
